import LanderBreadcrumb from "./LanderBreadcrumb";
import { useLanderBlocks } from "../hooks/useLanderBlocks";
import { useLightningLanderContext } from "../providers/LightningLanderProvider";

function LanderBlockBreadcrumb() {
    const { setBlocks } = useLanderBlocks();
    const { component, setComponent } = useLightningLanderContext()


    if (!component) {
        return <></>;
    }

    return (
        <LanderBreadcrumb
            component={component}
            setComponent={setComponent}
            setComponents={setBlocks}
        />
    );
}

export default LanderBlockBreadcrumb;